import * as types from '../types'

export default () => {
  return {
    type: types.POST_JOB_DONE,
  }
}
